import React from 'react';
// gatsby
import { useStaticQuery, graphql } from 'gatsby';
//styles
import styles from './our-projects.module.css';
//components
import ProjectCard from './project-card';

const Routes = require('../../routes').Routes;

interface IOurProjects {
  title?: string;
  backgroundColor?: string;
}

function OurProjects({ title = 'Featured Projects:', backgroundColor = '#fff' }: IOurProjects) {
  const data = useStaticQuery(graphql`
    query {
      condogenie: file(relativePath: { eq: "career/condogenie.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      everypig: file(relativePath: { eq: "career/everypig.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1530) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      adact: file(relativePath: { eq: "adact-cover-subtitles.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      heyPractice: file(relativePath: { eq: "hey-practice-cover-subtitles.png" }) {
        childImageSharp {
          fluid(maxWidth: 1200, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      react: file(relativePath: { eq: "career/react-logo.svg" }) {
        publicURL
      }
      ruby: file(relativePath: { eq: "career/ruby-logo.svg" }) {
        publicURL
      }
      node: file(relativePath: { eq: "career/node-js-logo.svg" }) {
        publicURL
      }
      amazon: file(relativePath: { eq: "career/amazon-logo.svg" }) {
        publicURL
      }
      precire: file(relativePath: { eq: "career/precire.svg" }) {
        publicURL
      }
      ibm: file(relativePath: { eq: "career/ibm-watson.svg" }) {
        publicURL
      }
    }
  `);

  const cardProps = [
    // {
    //   image: data.ladderOut.childImageSharp.fluid,
    //   cardTitle: 'Ladder Out',
    //   description:
    //     "An online service enabling patients to overcome unhealthy addictions using the app's support system.",
    //   industry: 'Mental Health',
    //   location: 'Sweden',
    //   team: '4 specialists (PM, QA, Devs)',
    //   technology: [data.react.publicURL, data.ruby.publicURL],
    //   source: `${GATSBY_STRAPI_CDN}/video/ladderout_min.mp4`,
    //   route: Routes.CASE_STUDIES_LADDEROUT,
    // },
    // {
    //   image: data.skillent.childImageSharp.fluid,
    //   cardTitle: 'Skilent',
    //   description:
    //     'Skilent leverages the work of HR departments due to a set of management tools and recommendations.',
    //   industry: 'Recruiting software',
    //   location: 'USA',
    //   team: '4 specialists (PM, QA, Devs)',
    //   technology: [data.react.publicURL, data.node.publicURL],
    //   source: "skilent_final",
    //   route: Routes.CASE_STUDIES_SKILENT,
    // },
    {
      image: data.adact.childImageSharp.fluid,
      cardTitle: 'Adact',
      description:
        'World’s leading MarTech software that allows the creation of fully customizable interactive experiences',
      industry: 'MarTech',
      location: 'Estonia',
      team: '7 specialists (PM, Designer, QA, Frontend, Backend, DevOps)',
      technology: [data.node.publicURL, data.amazon.publicURL, data.react.publicURL],
      source: 'adact-final',
      route: Routes.CASE_STUDIES_ADACT,
    },
    {
      image: data.heyPractice.childImageSharp.fluid,
      cardTitle: 'HeyPractice',
      description: 'AI-based Interactive learning platform for Sales and Marketing teams',
      industry: 'EdTech',
      location: 'United Kingdom',
      team: '8 specialists (PM, QA, Fullstack, Frontend, Backend)',
      technology: [
        data.react.publicURL,
        data.amazon.publicURL,
        data.node.publicURL,
        data.precire.publicURL,
        data.ibm.publicURL,
      ],
      source: 'hey_practice',
      route: Routes.CASE_STUDIES_HEYPRACTICE,
    },
    {
      image: data.everypig.childImageSharp.fluid,
      cardTitle: 'Everypig',
      description:
        'AI-based tool for pig owners and veterinarians. It helps predict diseases and avoid financial risks',
      industry: 'Agritech',
      location: 'USA',
      team: '7 specialists (PM, QA, DevOps, Devs)',
      technology: [data.react.publicURL, data.ruby.publicURL],
      source: 'everypig_2',
      route: Routes.CASE_STUDIES_EVERYPIG_LOGISTIC,
    },
    {
      image: data.condogenie.childImageSharp.fluid,
      cardTitle: 'Condogenie',
      description:
        'A real-time platform that enables communications between service companies and condo residents',
      industry: 'Proptech',
      location: 'Canada',
      team: '5 specialists (PM, QA, Full stack dev, DevOps, UI designer)',
      technology: [data.react.publicURL, data.ruby.publicURL],
      source: 'condogenie',
      route: Routes.CASE_STUDIES_CONDOGENIE,
    },
  ];

  return (
    <section className={styles.container} style={{ backgroundColor }}>
      <div className={styles.innerContainer}>
        <h2 className={styles.title}>{title}</h2>

        <ul className={styles.cardContainer}>
          {cardProps.map((prop, index) => (
            <ProjectCard {...prop} key={`${prop.cardTitle}-${index}`} />
          ))}
        </ul>
      </div>
    </section>
  );
}

export default OurProjects;
